import { render } from "./CreateHotelChain.vue?vue&type=template&id=5f899f5b"
import script from "./CreateHotelChain.vue?vue&type=script&lang=js"
export * from "./CreateHotelChain.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__